module.exports = '4.2.0-snapshot'
